// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".one-key-booking-dialog .el-dialog__body[data-v-3384ece6] {\n  padding: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
